module.exports = __webpack_public_path__ + "img/bg.97a618b3.png";